import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_FAMILY_MEDICAL_HISTORY' as const;
export { ExportStatus as Status };
